/**
 * Políticas de límite de crédito por cliente (cuenta corriente).
 * Solo validación/visualización; no modifica el motor de saldos.
 */

export const POLITICA_LIMITE_CREDITO = {
  ADVERTIR: 'advertir',
  BLOQUEAR: 'bloquear',
  AUTORIZAR: 'autorizar'
};

export const POLITICA_LIMITE_CREDITO_DEFAULT = POLITICA_LIMITE_CREDITO.ADVERTIR;

/**
 * @param {Object|null|undefined} cliente
 * @returns {number} 0 = sin límite configurado
 */
export function parseLimiteCreditoCliente(cliente) {
  if (!cliente || cliente.limite_credito == null) return 0;
  const n = Number(cliente.limite_credito);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * @param {number} limite
 * @param {number} saldoActual - saldo oficial (deuda positiva)
 * @returns {number|null} null si no hay límite
 */
export function calcularDisponibleCredito(limite, saldoActual) {
  const lim = Number(limite) || 0;
  if (lim <= 0) return null;
  const deuda = Math.max(0, Number(saldoActual) || 0);
  return Math.max(0, lim - deuda);
}

/**
 * Evalúa si una venta a CC supera el límite del cliente.
 * @param {Object} params
 * @param {Object} params.cliente
 * @param {number} params.saldoActual - saldo oficial (GET /clientes/:id/saldo)
 * @param {number} params.saldoPendienteVenta - saldo_pendiente de computeVentaPago
 * @param {string} [params.politica]
 */
export function evaluarLimiteCreditoVenta({
  cliente,
  saldoActual,
  saldoPendienteVenta,
  politica = POLITICA_LIMITE_CREDITO_DEFAULT
}) {
  const limite = parseLimiteCreditoCliente(cliente);
  const tieneLimite = limite > 0;
  const deudaActual = Math.max(0, Number(saldoActual) || 0);
  const saldoNuevaVenta = Math.max(0, Number(saldoPendienteVenta) || 0);
  const totalProyectado = deudaActual + saldoNuevaVenta;
  const disponible = calcularDisponibleCredito(limite, deudaActual);
  const excedeLimite = tieneLimite && totalProyectado > limite + 0.001;

  return {
    tieneLimite,
    limite,
    deudaActual,
    saldoNuevaVenta,
    totalProyectado,
    disponible,
    excedeLimite,
    politica,
    debeBloquear: excedeLimite && politica === POLITICA_LIMITE_CREDITO.BLOQUEAR,
    debeAdvertir: excedeLimite && politica === POLITICA_LIMITE_CREDITO.ADVERTIR
  };
}
